<script setup lang="ts">
import Button from "primevue/button";
import { ref } from "vue";
import { Project, Recipients } from "../../../types/PersologOnlineTypes";
import { useI18n } from "vue-i18n";
import { getChartPdfUrl } from "../../../utils/PdfUtils.ts";
import { BENCHMARK_BASIC, BENCHMARK_JOBMATCH } from "../../../utils/ProjectUtils";
import { openInNewTabSafariSafe } from "../../../utils/GeneralUtils";

const props = defineProps({
    project: {
        type: Object as () => Project,
        required: true,
    },
    hasGeneratedParticipants: {
        type: Boolean,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const { t } = useI18n();

const pdfUrl = ref("");
const impersonated = localStorage.getItem("impersonatedAccount") !== null;
const viewable = !impersonated && props.project.recipients !== Recipients.PARTICIPANT;
const loading = ref(false);
const productId = ref("benchmarkprofile");

async function viewPdf(language: string) {
    try {
        loading.value = true;
        pdfUrl.value = await getChartPdfUrl(BENCHMARK_JOBMATCH, props.project?.id as number, language);
        productId.value = BENCHMARK_JOBMATCH;
        openInNewTabSafariSafe(pdfUrl.value);
        loading.value = false;
    } catch (e) {
        try {
            pdfUrl.value = await getChartPdfUrl(BENCHMARK_BASIC, props.project?.id as number, language);
            productId.value = BENCHMARK_BASIC;
            openInNewTabSafariSafe(pdfUrl.value);
            loading.value = false;
        } catch (error) {
            console.error("Error displaying PDF:", error, e);
            loading.value = false;
        }
    }
}

</script>

<template>
    <Button
        :disabled="!viewable || disabled"
        :icon="loading ? 'pi pi-spin pi-spinner' : 'pi pi-eye'"
        :label="t('project-details.participants.actionsLabels.view-profile')"
        @click="viewPdf(props.project.language!)"
        v-tooltip.top="{ value: t('project-details.participants.tooltips.view'), showDelay: 500 }"
        style="margin-left: 10px"
    ></Button>
</template>
